import { render, staticRenderFns } from "./EditLead.vue?vue&type=template&id=12a4f1f1&"
import script from "./EditLead.vue?vue&type=script&lang=js&"
export * from "./EditLead.vue?vue&type=script&lang=js&"
import style0 from "./EditLead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports